export default __webpack_public_path__ + "static/media/404.c6dc55bd.png";